module.exports = __webpack_public_path__ + "static/media/Calender.ec89dbd0.svg";